import { Repository } from 'app/services/database/repository';
import { UserModel } from 'app/views/user/models/user.model';

export enum Role {
    SuperAdmin = 'superadmin',
    User = 'user',
    Device = 'device'
}

export class RoleRepository extends Repository<Role> {
    protected get path() { return '/roles/'; }
}



// WEBPACK FOOTER //
// ./src/app/services/database/role.repository.ts